(function () {
  var form = document.getElementById('CustomProjectForm');
  if (!form || form.dataset.ready === 'true') return;
  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
  if (!steps.length) return;
  form.dataset.ready = 'true';

  var labels = [
    'Choose product',
    'Size and photos',
    'Material and color',
    'Construction details',
    'Contact and notes',
    'Review and submit'
  ];
  var guidance = {
    'Gate Screen': 'Measure the opening you want covered, side to side and top to bottom. Use the finished cover size, including any overlap past the frame.',
    'Pergola Cover': 'Measure the finished cover, not the outside of the beams. Width is one direction and length is the other. Add a drop only if the edge hangs down.',
    'Privacy Screen': 'Measure the finished screen, side to side and top to bottom.',
    'Shade Panel': 'Measure the finished panel, side to side and along the other edge.',
    'Shade Sail': 'Measure each finished edge, not the space between the posts. For a rectangle, width and length are enough. For a triangle, add the third side.',
    Other: 'Enter the finished size you want us to make.'
  };
  var buildsFor = {
    'Gate Screen': ['hem', 'grommets', 'other'],
    'Pergola Cover': ['hem', 'grommets', 'pocket', 'other'],
    'Privacy Screen': ['hem', 'grommets', 'other'],
    'Shade Panel': ['hem', 'grommets', 'pocket', 'other'],
    'Shade Sail': ['hem', 'grommets', 'other'],
    Other: ['hem', 'grommets', 'pocket', 'other']
  };
  var thirdCopy = {
    'Shade Sail': { label: 'Third side', help: 'Add this for a triangle. Leave it blank for a rectangle.' },
    'Pergola Cover': { label: 'Drop', help: 'How far the edge hangs down, if it does. Optional.' },
    Other: { label: 'Third side or drop', help: 'Optional.' }
  };
  var colors = [
    ['Banha Beige', '#C4B39A', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Panel|Shade Sail|Other'],
    ['Beige', '#D6C6A5', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Sail|Other'],
    ['Black', '#1C1C1C', 'Gate Screen|Pergola Cover|Privacy Screen|Other'],
    ['Blue', '#3A6EA5', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Sail|Other'],
    ['Brown', '#6B4A2F', 'Shade Sail|Other'],
    ['Burgundy Red', '#7A2430', 'Pergola Cover|Shade Sail|Other'],
    ['Dark Brown', '#4A2E1F', 'Shade Sail|Other'],
    ['Dark Green', '#1F4D3A', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Sail|Other'],
    ['Desert Sand', '#C2B280', 'Pergola Cover|Shade Sail|Other'],
    ['Forest Green', '#2E5A3C', 'Shade Sail|Other'],
    ['Grey', '#8A8D8F', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Panel|Shade Sail|Other'],
    ['Mango Yellow', '#E2A122', 'Pergola Cover|Shade Sail|Other'],
    ['Mocha Brown', '#6F4E37', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Panel|Shade Sail|Other'],
    ['Muddy Water', '#8B7355', 'Pergola Cover|Shade Sail|Other'],
    ['Navy Grey', '#4E5964', 'Shade Panel|Other'],
    ['Pear Green', '#7BA05B', 'Shade Sail|Other'],
    ['Pecan Brown', '#A67B5B', 'Shade Sail|Other'],
    ['Royal Blue', '#2E5090', 'Pergola Cover|Shade Sail|Other'],
    ['Rust Red', '#A84B2F', 'Shade Sail|Other'],
    ['Sand', '#CDB891', 'Pergola Cover|Shade Panel|Shade Sail|Other'],
    ['Smoke', '#9A9A96', 'Gate Screen|Privacy Screen|Shade Panel|Other'],
    ['Smoke Tan', '#B5A48A', 'Pergola Cover|Other'],
    ['Tangerine Orange', '#E07A2F', 'Shade Sail|Other'],
    ['Terracota Red', '#C45C3E', 'Shade Sail|Other'],
    ['Turquoise', '#3AA8A0', 'Shade Sail|Other'],
    ['Walnut', '#5C4033', 'Gate Screen|Pergola Cover|Privacy Screen|Shade Panel|Shade Sail|Other'],
    ['White', '#F4F4F2', 'Pergola Cover|Shade Panel|Shade Sail|Other']
  ];

  var progress = form.querySelector('[data-progress]');
  var error = form.querySelector('[data-error]');
  var backButton = form.querySelector('[data-back]');
  var nextButton = form.querySelector('[data-next]');
  var submitButton = form.querySelector('[data-submit]');
  var review = form.querySelector('[data-review]');
  var body = form.querySelector('[data-brief]');
  var photoInput = form.querySelector('[data-photos]');
  var photoList = form.querySelector('[data-photo-list]');
  var photoField = form.querySelector('[data-photo-field]');
  var unit = form.querySelector('[data-unit]');
  var measureHelp = form.querySelector('[data-measure-help]');
  var colorList = form.querySelector('[data-color-list]');
  var colorDetail = form.querySelector('[data-color-detail]');
  var sidesDetail = form.querySelector('[data-sides-detail]');
  var spacingDetail = form.querySelector('[data-spacing-detail]');
  var pocketSize = form.querySelector('[data-pocket-size]');
  var uploadRoot = form.closest('[data-upload-variant]');
  var variantId = uploadRoot ? uploadRoot.getAttribute('data-upload-variant') : '';
  var index = 0;
  var photos = [];
  var submitted = false;
  var started = false;
  var restoring = false;
  var draftKey = 'alion_custom_quote_draft';

  function selected(name) {
    var fields = form.querySelectorAll('[name="' + name + '"]:checked');
    var i;
    for (i = 0; i < fields.length; i += 1) {
      if (!fields[i].disabled) return fields[i].value;
    }
    return '';
  }

  function selectedAll(name) {
    return Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]:checked')).filter(function (field) {
      return !field.disabled;
    }).map(function (field) {
      return field.value;
    });
  }

  function fieldValue(name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function setError(message) {
    error.hidden = !message;
    error.textContent = message || '';
    if (message && error.scrollIntoView) error.scrollIntoView({ block: 'nearest' });
  }

  function partBox(part) {
    return form.querySelector('[data-part="' + part + '"]');
  }

  function partField(part, kind) {
    return partBox(part).querySelector('[data-' + kind + ']');
  }

  function inchesMode() {
    return unit.value === 'Inches';
  }

  function projectType() {
    return selected('contact[Project type]');
  }

  function thirdInfo() {
    return thirdCopy[projectType()] || null;
  }

  function setGroup(group, visible) {
    if (!group) return;
    group.hidden = !visible;
    Array.prototype.forEach.call(group.querySelectorAll('input, textarea, select'), function (input) {
      input.disabled = !visible;
    });
  }

  function numberOrNull(value) {
    if (!/^\d+(\.\d+)?$/.test(value)) return null;
    return Number(value);
  }

  function round2(value) {
    return Math.round(value * 100) / 100;
  }

  function readTotal(part) {
    if (inchesMode()) {
      var raw = partField(part, 'total').value.trim();
      if (!raw) return { empty: true };
      var total = numberOrNull(raw);
      if (total === null || total <= 0) return { invalid: true };
      return { total: total };
    }
    var feetRaw = partField(part, 'feet').value.trim();
    var inchRaw = partField(part, 'inches').value.trim();
    if (!feetRaw && !inchRaw) return { empty: true };
    if (feetRaw && !/^\d+$/.test(feetRaw)) return { invalid: true, message: 'Enter whole feet, then the leftover inches.' };
    if (inchRaw && numberOrNull(inchRaw) === null) return { invalid: true, message: 'Enter inches using numbers only.' };
    if (inchRaw && Number(inchRaw) >= 12) return { invalid: true, message: 'Inches must be less than 12. Put the extra feet in the feet field.' };
    var totalInches = (feetRaw ? Number(feetRaw) : 0) * 12 + (inchRaw ? Number(inchRaw) : 0);
    if (!(totalInches > 0)) return { invalid: true };
    return { total: totalInches };
  }

  function formatTotal(total) {
    if (!(total > 0)) return '';
    var whole = Math.floor(total / 12 + 1e-9);
    var rem = round2(total - whole * 12);
    return whole + ' ft ' + rem + ' in (' + round2(total) + ' in)';
  }

  function sizeText() {
    var width = readTotal('width');
    var length = readTotal('length');
    var parts = [];
    if (!width.empty || !length.empty) {
      parts.push((width.total ? formatTotal(width.total) : '—') + ' × ' + (length.total ? formatTotal(length.total) : '—'));
    }
    var third = thirdInfo();
    if (third) {
      var side = readTotal('third');
      if (side.total) parts.push(third.label + ': ' + formatTotal(side.total));
    }
    var line = parts.join('; ');
    if (measureHelp.checked) return line ? 'Asked for help measuring. Entered: ' + line : 'Asked for help measuring';
    return line;
  }

  function updateSizePreview() {
    var preview = form.querySelector('[data-size-preview]');
    preview.textContent = sizeText();
  }

  function updateQuantity() {
    var echo = form.querySelector('[data-quantity-echo]');
    var quantity = fieldValue('contact[Quantity]') || '1';
    echo.textContent = 'Quantity: ' + quantity;
  }

  function renderColors() {
    colorList.replaceChildren();
    colors.forEach(function (color) {
      colorList.appendChild(colorChoice(color[0], color[1], color[2]));
    });
    colorList.appendChild(colorChoice('Other / Custom Color', '', '*'));
    colorList.appendChild(colorChoice('Not Sure', '', '*'));
  }

  function colorChoice(name, hex, types) {
    var label = document.createElement('label');
    label.className = 'custom-project__choice';
    label.setAttribute('data-color-for', types);
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'color';
    input.value = name;
    var span = document.createElement('span');
    if (hex) {
      var swatch = document.createElement('i');
      swatch.className = 'custom-project__swatch';
      swatch.style.background = hex;
      swatch.setAttribute('aria-hidden', 'true');
      span.appendChild(swatch);
    }
    span.appendChild(document.createTextNode(name));
    label.appendChild(input);
    label.appendChild(span);
    return label;
  }

  function syncConditional() {
    var type = projectType();
    setGroup(form.querySelector('[data-type-other]'), type === 'Other');
    if (type !== 'Other') form.querySelector('[name="contact[Project type detail]"]').value = '';

    var goals = selectedAll('goal');
    setGroup(form.querySelector('[data-goal-other]'), goals.indexOf('Other') !== -1);
    if (goals.indexOf('Other') === -1) form.querySelector('[name="contact[Goal detail]"]').value = '';

    var allowed = buildsFor[type] || [];
    Array.prototype.forEach.call(form.querySelectorAll('[data-build]'), function (group) {
      var on = allowed.indexOf(group.getAttribute('data-build')) !== -1;
      setGroup(group, on);
      if (!on) {
        Array.prototype.forEach.call(group.querySelectorAll('input'), function (input) {
          input.checked = false;
        });
      }
    });

    var grommets = form.querySelector('[data-grommets]');
    var grommetOn = grommets && grommets.checked && !grommets.disabled;
    setGroup(form.querySelector('[data-grommet-options]'), grommetOn);
    setGroup(form.querySelector('[data-selected-sides]'), grommetOn && selected('grommet_placement') === 'Selected Sides');
    setGroup(form.querySelector('[data-custom-spacing]'), grommetOn && selected('grommet_spacing') === 'Custom');
    var pocket = form.querySelector('[data-pocket]');
    setGroup(form.querySelector('[data-pocket-options]'), pocket && pocket.checked && !pocket.disabled);

    var note = form.querySelector('[data-grommet-note]');
    note.textContent = type === 'Shade Sail'
      ? 'Shade sails usually need one ring at each corner. If you want rings along an edge, tell us the spacing.'
      : 'Where should the rings go, and how far apart?';
    form.querySelector('[data-construction-prompt]').textContent = type === 'Shade Sail'
      ? 'Choose the edge finish. Shade sails usually get a stainless steel ring at each corner.'
      : 'Choose the edge finish. Stainless steel grommets are our standard.';

    var guide = form.querySelector('[data-measure-guidance]');
    guide.textContent = guidance[type] || 'Use the finished size you want made, not the outside of the frame.';
    var third = thirdInfo();
    var thirdBox = partBox('third');
    thirdBox.hidden = !third;
    if (third) {
      form.querySelector('[data-third-label]').textContent = third.label;
      form.querySelector('[data-third-help]').textContent = third.help;
    }
    ['width', 'length', 'third'].forEach(function (part) {
      var box = partBox(part);
      var show = part !== 'third' || !!third;
      setGroup(box.querySelector('[data-feet-group]'), show && !inchesMode());
      setGroup(box.querySelector('[data-inch-group]'), show && inchesMode());
    });

    var material = selected('contact[Material]');
    form.querySelector('[data-rain-warning]').hidden = !(goals.indexOf('Rain Protection') !== -1 && material === 'HDPE / Breathable');

    var color = selected('color');
    Array.prototype.forEach.call(colorList.querySelectorAll('[data-color-for]'), function (label) {
      var allowedColors = label.getAttribute('data-color-for');
      var show = allowedColors === '*' || (!type ? false : allowedColors.split('|').indexOf(type) !== -1);
      if (allowedColors === '*') show = true;
      label.hidden = !show;
      var input = label.querySelector('input');
      input.disabled = !show;
      if (!show) input.checked = false;
    });
    setGroup(form.querySelector('[data-color-other]'), selected('color') === 'Other / Custom Color');
    if (selected('color') !== 'Other / Custom Color') colorDetail.value = '';

    updateSizePreview();
    updateQuantity();
  }

  function validateDimension(part, required, label) {
    var result = readTotal(part);
    if (result.empty) {
      if (required && !measureHelp.checked) return 'Enter the ' + label.toLowerCase() + '.';
      return '';
    }
    if (result.invalid) return result.message || 'Check the ' + label.toLowerCase() + '.';
    return '';
  }

  function colorText() {
    var color = selected('color');
    if (color === 'Other / Custom Color') {
      var detail = colorDetail.value.trim();
      return detail ? 'Other: ' + detail : '';
    }
    return color;
  }

  function useText() {
    var goals = selectedAll('goal');
    var text = goals.filter(function (goal) { return goal !== 'Other'; }).join(', ');
    if (goals.indexOf('Other') !== -1) {
      var detail = fieldValue('contact[Goal detail]');
      text = text ? text + ', Other: ' + detail : 'Other: ' + detail;
    }
    return text;
  }

  function constructionText() {
    var lines = selectedAll('build').slice();
    if (selected('build') && lines.indexOf('Stainless steel grommets') !== -1) {
      var placement = selected('grommet_placement');
      if (placement) lines.push('Grommet placement: ' + placement);
      if (placement === 'Selected Sides' && sidesDetail.value.trim()) lines.push('Sides: ' + sidesDetail.value.trim());
      var spacing = selected('grommet_spacing');
      if (spacing === 'Custom' && spacingDetail.value.trim()) lines.push('Grommet spacing: ' + spacingDetail.value.trim());
      else if (spacing) lines.push('Grommet spacing: ' + spacing);
    }
    if (lines.indexOf('Rod pocket') !== -1) {
      var location = selected('pocket_location');
      if (location) lines.push('Rod pocket location: ' + location);
      if (pocketSize.value.trim()) lines.push('Pocket size or rod diameter: ' + pocketSize.value.trim());
    }
    return lines.join('. ');
  }

  function photoUrls() {
    return photos.map(function (photo) { return photo.url; }).filter(Boolean);
  }

  function writePhotos() {
    var urls = photoUrls();
    photoField.value = photos.length && urls.length === photos.length ? urls.join('\n') : photos.length ? '' : 'None';
  }

  function validate(step) {
    if (step === 0) {
      var type = projectType();
      if (!type) return 'Choose a product.';
      if (type === 'Other' && fieldValue('contact[Project type detail]').length < 2) return 'Describe the project.';
      var goals = selectedAll('goal');
      if (!goals.length) return 'Choose what it should do.';
      if (goals.indexOf('Other') !== -1 && fieldValue('contact[Goal detail]').length < 2) return 'Describe the other goal.';
      return '';
    }
    if (step === 1) {
      var widthMessage = validateDimension('width', true, 'Finished width');
      if (widthMessage) return widthMessage;
      var lengthMessage = validateDimension('length', true, 'Finished length');
      if (lengthMessage) return lengthMessage;
      if (thirdInfo()) {
        var thirdMessage = validateDimension('third', false, thirdInfo().label);
        if (thirdMessage) return thirdMessage;
      }
      var quantity = fieldValue('contact[Quantity]');
      if (!/^\d+$/.test(quantity) || Number(quantity) < 1 || Number(quantity) > 999) return 'Enter a quantity from 1 to 999.';
      var pending = photos.some(function (photo) { return photo.status === 'uploading'; });
      if (pending) return 'Wait for the photos to finish uploading.';
      var failed = photos.some(function (photo) { return photo.status !== 'done' || !photo.url; });
      if (failed) return 'Remove the photo that did not upload, or try it again.';
      return '';
    }
    if (step === 2) {
      if (!selected('contact[Material]')) return 'Choose a material.';
      var color = selected('color');
      if (!color) return 'Choose a color.';
      if (color === 'Other / Custom Color' && colorDetail.value.trim().length < 2) return 'Describe the custom color.';
      return '';
    }
    if (step === 3) {
      var chosen = selectedAll('build');
      if (!chosen.length) return 'Choose a construction option.';
      if (chosen.indexOf('Stainless steel grommets') !== -1) {
        if (!selected('grommet_placement')) return 'Choose where the grommets should go.';
        if (selected('grommet_placement') === 'Selected Sides' && sidesDetail.value.trim().length < 2) return 'Tell us which sides need grommets.';
        if (!selected('grommet_spacing')) return 'Choose the grommet spacing.';
        if (selected('grommet_spacing') === 'Custom' && spacingDetail.value.trim().length < 2) return 'Describe the custom spacing.';
      }
      if (chosen.indexOf('Rod pocket') !== -1) {
        if (!selected('pocket_location')) return 'Choose where the rod pocket should go.';
        if (pocketSize.value.trim().length < 2) return 'Enter the finished pocket size or the rod diameter. If you are not sure, type Not sure.';
      }
      return '';
    }
    if (step === 4) {
      if (fieldValue('contact[Name]').length < 2) return 'Enter your name.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue('contact[email]'))) return 'Enter a valid email.';
      return '';
    }
    return '';
  }

  function compose() {
    var type = projectType();
    var typeLine = type === 'Other' ? 'Other: ' + fieldValue('contact[Project type detail]') : type;
    var size = sizeText() || '—';
    var urls = photoUrls();
    form.querySelector('[data-goal-field]').value = useText();
    form.querySelector('[data-size-field]').value = size;
    form.querySelector('[data-help-field]').value = measureHelp.checked ? 'Yes' : 'No';
    form.querySelector('[data-color-field]').value = colorText();
    form.querySelector('[data-construction-field]').value = constructionText();
    writePhotos();
    var lines = [];
    if (fieldValue('contact[Product]')) lines.push(['Product', fieldValue('contact[Product]'), -1]);
    if (fieldValue('contact[Product URL]')) lines.push(['Product page', fieldValue('contact[Product URL]'), -1]);
    if (fieldValue('contact[Selected size]')) lines.push(['Selected size', fieldValue('contact[Selected size]'), -1]);
    lines.push(['Product type', typeLine, 0]);
    lines.push(['Intended use', useText(), 0]);
    lines.push(['Finished size', size, 1]);
    lines.push(['Quantity', fieldValue('contact[Quantity]'), 1]);
    lines.push(['Photos', urls.length ? urls.length + (urls.length === 1 ? ' photo' : ' photos') : 'None', 1, true]);
    lines.push(['Material', selected('contact[Material]'), 2]);
    lines.push(['Color', colorText(), 2]);
    lines.push(['Construction', constructionText(), 3]);
    lines.push(['Name', fieldValue('contact[Name]'), 4]);
    lines.push(['Email', fieldValue('contact[email]'), 4]);
    lines.push(['Phone', fieldValue('contact[Phone number]') || '—', 4]);
    lines.push(['Additional notes', fieldValue('contact[Notes]') || '—', 4]);
    body.value = lines.map(function (line) {
      return line[0] + ': ' + line[1];
    }).join('\n');
    if (urls.length) body.value += '\nPhoto links:\n' + urls.join('\n');
    return lines;
  }

  function answer(line) {
    var row = document.createElement('div');
    row.className = 'custom-project__row';
    var term = document.createElement('dt');
    term.textContent = line[0];
    var detail = document.createElement('dd');
    detail.textContent = line[1] || '—';
    if (line[3]) {
      var gallery = document.createElement('div');
      gallery.className = 'custom-project__review-photos';
      photos.forEach(function (photo) {
        if (!photo.preview) return;
        var image = document.createElement('img');
        image.src = photo.preview;
        image.alt = '';
        gallery.appendChild(image);
      });
      if (gallery.childNodes.length) detail.appendChild(gallery);
    }
    row.appendChild(term);
    row.appendChild(detail);
    if (line[2] >= 0) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = 'Edit';
      button.addEventListener('click', function () {
        show(line[2], true);
      });
      row.appendChild(button);
    }
    return row;
  }

  function renderReview() {
    var lines = compose();
    review.replaceChildren();
    lines.forEach(function (line) {
      review.appendChild(answer(line));
    });
  }

  function show(next, focus) {
    index = next;
    steps.forEach(function (step, stepIndex) {
      step.hidden = stepIndex !== index;
    });
    progress.textContent = 'Step ' + (index + 1) + ' of ' + labels.length + ' — ' + labels[index];
    backButton.hidden = index === 0;
    nextButton.hidden = index === steps.length - 1;
    submitButton.hidden = index !== steps.length - 1;
    setError('');
    syncConditional();
    updateQuantity();
    if (index === steps.length - 1) renderReview();
    if (focus) {
      var heading = steps[index].querySelector('h2');
      if (heading) heading.focus();
    }
  }

  function hostedUrl(value) {
    if (!value || typeof value !== 'string') return '';
    var url = value.trim();
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (url.indexOf('/') === 0) url = window.location.origin + url;
    try {
      var parsed = new URL(url);
      if (parsed.protocol !== 'https:') return '';
      var host = parsed.hostname;
      var shopHost = window.location.hostname;
      var allowed = host === 'cdn.shopify.com' || host === shopHost || host.slice(-14) === '.shopifycdn.com' || host.slice(-13) === '.myshopify.com';
      if (!allowed) return '';
      if (parsed.pathname.indexOf('/cdn/') === -1 && parsed.pathname.indexOf('/files/') === -1 && parsed.pathname.indexOf('/s/files/') === -1) return '';
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function removeLine(key) {
    function once() {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (response) { return response.json(); });
    }
    function cartHas(keyToFind) {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          return (cart.items || []).some(function (item) { return item.key === keyToFind; });
        });
    }
    return once().then(function () { return cartHas(key); }).then(function (still) {
      if (!still) return;
      return once().then(function () { return cartHas(key); }).then(function (remains) {
        if (remains) throw new Error('cart');
      });
    });
  }

  function uploadPhoto(photo) {
    photo.status = 'uploading';
    photo.progress = 0.05;
    renderPhotos();
    if (!variantId) {
      photo.status = 'error';
      photo.error = 'Photo upload is not available right now. Please try again in a moment.';
      renderPhotos();
      return;
    }
    var payload = new FormData();
    payload.append('id', variantId);
    payload.append('quantity', '1');
    payload.append('properties[Quote photo]', photo.file);
    payload.append('properties[_quote_token]', String(Date.now()) + Math.random());
    var request = new XMLHttpRequest();
    request.open('POST', '/cart/add.js');
    request.setRequestHeader('Accept', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.upload.onprogress = function (event) {
      if (!event.lengthComputable) return;
      photo.progress = event.loaded / event.total;
      if (photo.fill) photo.fill.style.width = Math.round(photo.progress * 100) + '%';
    };
    request.onload = function () {
      var data;
      try { data = JSON.parse(request.responseText || '{}'); } catch (error) { data = {}; }
      if (request.status >= 400 || data.status || data.errors) {
        photo.status = 'error';
        photo.error = data.description || data.message || 'That photo did not upload. Please try again.';
        renderPhotos();
        return;
      }
      var raw = data.properties && (data.properties['Quote photo'] || data.properties['quote photo']);
      var url = hostedUrl(raw);
      var key = data.key;
      if (!url || !key) {
        photo.status = 'error';
        photo.error = 'That photo did not upload. Please try again.';
        if (key) removeLine(key).catch(function () {});
        renderPhotos();
        return;
      }
      removeLine(key).then(function () {
        photo.url = url;
        photo.status = 'done';
        photo.progress = 1;
        photo.error = '';
        renderPhotos();
        saveDraft();
      }).catch(function () {
        photo.status = 'error';
        photo.error = 'We could not finish saving that photo. Check your cart for an extra item, remove it, and try the photo again.';
        renderPhotos();
      });
    };
    request.onerror = function () {
      photo.status = 'error';
      photo.error = 'That photo did not upload. Please try again.';
      renderPhotos();
    };
    request.send(payload);
  }

  function renderPhotos() {
    photoList.replaceChildren();
    photos.forEach(function (photo, photoIndex) {
      var card = document.createElement('div');
      card.className = 'custom-project__photo';
      if (photo.preview) {
        var image = document.createElement('img');
        image.src = photo.preview;
        image.alt = '';
        card.appendChild(image);
      }
      var bar = document.createElement('div');
      bar.className = 'custom-project__bar';
      bar.setAttribute('role', 'progressbar');
      var fill = document.createElement('span');
      fill.style.width = Math.round((photo.progress || 0) * 100) + '%';
      photo.fill = fill;
      bar.appendChild(fill);
      card.appendChild(bar);
      var status = document.createElement('p');
      status.textContent = photo.error || (photo.status === 'done' ? 'Uploaded' : 'Uploading');
      card.appendChild(status);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'link';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        if (photo.preview && photo.preview.indexOf('blob:') === 0) URL.revokeObjectURL(photo.preview);
        photos.splice(photoIndex, 1);
        renderPhotos();
      });
      card.appendChild(remove);
      photoList.appendChild(card);
    });
    writePhotos();
  }

  function addPhoto(file) {
    var allowed = /^image\/(jpeg|png|webp)$/.test(file.type) || /\.(jpe?g|png|webp)$/i.test(file.name);
    var photo = {
      file: file,
      name: file.name,
      preview: '',
      url: '',
      status: 'uploading',
      progress: 0,
      error: ''
    };
    if (!allowed) {
      photo.status = 'error';
      photo.error = 'Use a JPG, PNG, or WEBP photo.';
    } else if (!file.size) {
      photo.status = 'error';
      photo.error = 'That file is empty.';
    } else if (file.size > 20 * 1024 * 1024) {
      photo.status = 'error';
      photo.error = 'Each photo must be 20 MB or smaller.';
    } else {
      photo.preview = URL.createObjectURL(file);
    }
    photos.push(photo);
    renderPhotos();
    if (photo.status !== 'error') uploadPhoto(photo);
  }

  function trackStart() {
    if (started) return;
    started = true;
    try {
      if (sessionStorage.getItem('alion_custom_quote_start') === '1') return;
    } catch (error) {}
    var tries = 0;
    function send() {
      tries += 1;
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        try { sessionStorage.setItem('alion_custom_quote_start', '1'); } catch (error) {}
        Shopify.analytics.publish('custom_quote_start', { form_id: 'custom_project' });
        return;
      }
      if (tries < 20) window.setTimeout(send, 250);
    }
    send();
  }

  function saveDraft() {
    if (restoring) return;
    var fields = [];
    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || field.type === 'file') return;
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
      fields.push({ name: field.name, value: field.value, kind: field.type });
    });
    var draft = {
      fields: fields,
      help: measureHelp.checked,
      colorDetail: colorDetail.value,
      sides: sidesDetail.value,
      spacing: spacingDetail.value,
      pocket: pocketSize.value,
      photos: photos.filter(function (photo) { return photo.url; }).map(function (photo) {
        return { url: photo.url };
      })
    };
    try { sessionStorage.setItem(draftKey, JSON.stringify(draft)); } catch (error) {}
  }

  function restoreDraft() {
    var raw;
    try { raw = sessionStorage.getItem(draftKey); } catch (error) { raw = ''; }
    if (!raw) return;
    var draft;
    try { draft = JSON.parse(raw); } catch (error) { return; }
    restoring = true;
    (draft.fields || []).forEach(function (field) {
      if (field.kind === 'radio' || field.kind === 'checkbox') {
        Array.prototype.forEach.call(form.querySelectorAll('[name="' + field.name.replace(/"/g, '\\"') + '"]'), function (input) {
          if (input.value === field.value) input.checked = true;
        });
      } else {
        var input = form.querySelector('[name="' + field.name.replace(/"/g, '\\"') + '"]');
        if (input && input.type !== 'file') input.value = field.value;
      }
    });
    measureHelp.checked = !!draft.help;
    colorDetail.value = draft.colorDetail || '';
    sidesDetail.value = draft.sides || '';
    spacingDetail.value = draft.spacing || '';
    pocketSize.value = draft.pocket || '';
    photos = (draft.photos || []).map(function (photo) {
      return { file: null, preview: photo.url, url: photo.url, status: 'done', progress: 1, error: '' };
    });
    restoring = false;
    renderPhotos();
  }

  function convertUnit() {
    var toInches = inchesMode();
    ['width', 'length', 'third'].forEach(function (part) {
      if (toInches) {
        var feetRaw = partField(part, 'feet').value.trim();
        var inchRaw = partField(part, 'inches').value.trim();
        var feet = /^\d+$/.test(feetRaw) ? Number(feetRaw) : 0;
        var inches = /^\d+(\.\d+)?$/.test(inchRaw) ? Number(inchRaw) : 0;
        if ((feetRaw || inchRaw) && inches < 12 && (feet > 0 || inches > 0)) {
          partField(part, 'total').value = String(round2(feet * 12 + inches));
        }
      } else {
        var raw = partField(part, 'total').value.trim();
        if (/^\d+(\.\d+)?$/.test(raw) && Number(raw) > 0) {
          var total = Number(raw);
          var whole = Math.floor(total / 12 + 1e-9);
          partField(part, 'feet').value = String(whole);
          partField(part, 'inches').value = String(round2(total - whole * 12));
        }
      }
    });
  }

  renderColors();
  restoreDraft();

  form.addEventListener('change', function (event) {
    if (event.target === unit) convertUnit();
    syncConditional();
    trackStart();
    saveDraft();
  });
  form.addEventListener('input', function () {
    updateSizePreview();
    updateQuantity();
    trackStart();
  });
  form.addEventListener('pointerdown', trackStart);
  photoInput.addEventListener('change', function () {
    var incoming = Array.prototype.slice.call(photoInput.files || []);
    photoInput.value = '';
    if (!incoming.length) return;
    var room = 3 - photos.length;
    if (room <= 0) {
      setError('You can add up to 3 photos.');
      return;
    }
    if (incoming.length > room) setError('You can add up to 3 photos. Extra photos were not added.');
    else setError('');
    incoming.slice(0, room).forEach(addPhoto);
    trackStart();
  });
  backButton.addEventListener('click', function () {
    saveDraft();
    show(Math.max(0, index - 1), true);
  });
  nextButton.addEventListener('click', function () {
    var message = validate(index);
    if (message) {
      setError(message);
      return;
    }
    saveDraft();
    show(Math.min(steps.length - 1, index + 1), true);
  });
  form.addEventListener('submit', function (event) {
    if (submitted) {
      event.preventDefault();
      return;
    }
    var step;
    for (step = 0; step < steps.length - 1; step += 1) {
      var message = validate(step);
      if (message) {
        event.preventDefault();
        show(step, true);
        setError(message);
        return;
      }
    }
    renderReview();
    saveDraft();
    submitted = true;
    submitButton.disabled = true;
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.textContent = 'Sending...';
  });

  var params = new URLSearchParams(window.location.search);
  var productTitle = params.get('product_title') || '';
  var productUrl = '';
  try {
    var parsed = new URL(params.get('product_url') || '', window.location.origin);
    if (parsed.origin === window.location.origin && parsed.pathname.indexOf('/products/') !== -1) {
      productUrl = parsed.origin + parsed.pathname;
    }
  } catch (error) {
    productUrl = '';
  }
  var variant = params.get('variant') || '';
  if (variant === 'Default Title') variant = '';
  if (productTitle) form.querySelector('[name="contact[Product]"]').value = productTitle;
  if (productUrl) form.querySelector('[name="contact[Product URL]"]').value = productUrl;
  if (variant) form.querySelector('[name="contact[Selected size]"]').value = variant;
  if (params.get('variant_id')) form.querySelector('[name="contact[Variant ID]"]').value = params.get('variant_id');
  var context = form.querySelector('[data-product-context]');
  if (productTitle) {
    context.hidden = false;
    var title = document.createElement('p');
    title.textContent = variant ? 'About this product: ' + productTitle + ' — ' + variant : 'About this product: ' + productTitle;
    context.appendChild(title);
    if (productUrl) {
      var linkRow = document.createElement('p');
      var link = document.createElement('a');
      link.href = productUrl;
      link.textContent = 'View product';
      linkRow.appendChild(link);
      context.appendChild(linkRow);
    }
  }

  var errorStep = form.querySelector('[data-error-step]');
  var start = errorStep ? Number(errorStep.value) : 0;
  if (!start || start < 0 || start >= steps.length) start = 0;
  syncConditional();
  show(start, false);
})();
